import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import Swal from 'sweetalert2';

declare var $: any;
declare var iziToast: any;

@Component({
  selector: 'app-emails-ticket-reassigned-report',
  templateUrl: './emails-ticket-reassigned-report.component.html',
  styleUrls: ['./emails-ticket-reassigned-report.component.css']
})
export class EmailsTicketReassignedReportComponent implements OnInit {

  recordNotFound = false;
  admin_id: any;
  loginUser: any;
  reports_list: any[] = [];
  pageLimit = 10;
  offset_count = 0;
  paginationData: any = { "info": "hide" };
  searchText: string = '';
  from_date: any = '';
  to_date: any = '';
  total_records = 0;
  res: any;



  constructor(
    private serverService: ServerService
  ) { }

  ngOnInit(): void {

    this.admin_id = localStorage.getItem('admin_id');
    this.loginUser = localStorage.getItem('userId');

    const today = new Date().toISOString().split('T')[0];

    // this.searchData({});
  }
    fetchData(data: any = {}) {
    let from_date = $('#from_date').val();
    let to_date = $('#to_date').val();
    this.searchText = data.search_text || this.searchText;
    if (from_date == null || from_date == '') {
      iziToast.warning({
        message: "Please fill From Date",
        position: 'topRight'
      });
      return false;
    }
    if (to_date == null || to_date == '') {
      iziToast.warning({
        message: "Please fill To Date",
        position: 'topRight'
      });
      return false;
    }
    var list_data = this.listDataInfo(data);
    let api_req: any = new Object();
    let report_req: any = new Object();

    report_req.action = "email_reassign_report";
    report_req.from_dt = from_date;
    report_req.to_dt = to_date;
    report_req.search_text = list_data.search_text;
    report_req.limit = list_data.limit;
    report_req.offset = list_data.offset || 0;

    api_req.operation = "ticket";
    api_req.moduleType = "ticket";
    api_req.api_type = "web";
    api_req.access_token = localStorage.getItem('access_token');
    api_req.element_data = report_req;

    Swal.fire({
      html:
        '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      focusConfirm: false,
      background: 'transparent'
    });

    this.serverService.sendServer(api_req).subscribe(
      (response: any) => {

        Swal.close();

        if (response.status == true ||
          response.result || response.result.status == true) {
          this.reports_list = response.result.data.list_data || [];
          this.offset_count = list_data.offset;
          this.paginationData = this.serverService.pagination({ 'offset': response.result.data.list_info.offset, 'total': response.result.data.list_info.total, 'page_limit': this.pageLimit });
          this.recordNotFound = this.reports_list.length == 0 ? true : false;

        } else {

          this.reports_list = [];
          this.recordNotFound = true;
        }

      },
      error => {

        Swal.close();

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load report'
        });

        console.log(error);
      }
    );
  }
  listDataInfo(list_data: any) {

    return {
      search_text: list_data.search_text || "",
      limit: this.pageLimit,
      offset: list_data.offset || 0
    };
  }
  searchData(data: any = {}) {
    let from_date = $('#from_date').val();
    let to_date = $('#to_date').val();
    this.searchText = data.search_text || this.searchText;
    if (from_date == null || from_date == '') {
      iziToast.warning({
        message: "Please fill From Date",
        position: 'topRight'
      });
      return false;
    }
    if (to_date == null || to_date == '') {
      iziToast.warning({
        message: "Please fill To Date",
        position: 'topRight'
      });
      return false;
    }
    var list_data = this.listDataInfo(data);
    let api_req: any = new Object();
    let report_req: any = new Object();

    report_req.action = "email_reassign_report";
    report_req.from_dt = from_date;
    report_req.to_dt = to_date;
    report_req.search_text = list_data.search_text;
    report_req.limit = list_data.limit;
    report_req.offset = list_data.offset || 0;

    api_req.operation = "ticket";
    api_req.moduleType = "ticket";
    api_req.api_type = "web";
    api_req.access_token = localStorage.getItem('access_token');
    api_req.element_data = report_req;

    Swal.fire({
      html:
        '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      focusConfirm: false,
      background: 'transparent'
    });

    this.serverService.sendServer(api_req).subscribe(
      (response: any) => {

        Swal.close();

        if (response.status == true ||
          response.result || response.result.status == true) {
          this.reports_list = response.result.data.list_data || [];
          this.offset_count = list_data.offset;
          this.paginationData = this.serverService.pagination({ 'offset': response.result.data.list_info.offset, 'total': response.result.data.list_info.total, 'page_limit': this.pageLimit });
          this.recordNotFound = this.reports_list.length == 0 ? true : false;

        } else {

          this.reports_list = [];
          this.recordNotFound = true;
        }

      },
      error => {

        Swal.close();

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load report'
        });

        console.log(error);
      }
    );
  }

  exportcsv() {

    let from_date = $('#from_date').val();
    let to_date = $('#to_date').val();

    if (!from_date) {
      iziToast.warning({ message: "Please select From Date", position: 'topRight' });
      return;
    }

    if (!to_date) {
      iziToast.warning({ message: "Please select To Date", position: 'topRight' });
      return;
    }

    let api_req: any = {
      operation: "ticket",
      moduleType: "ticket",
      api_type: "web",
      access_token: localStorage.getItem('access_token'),
      element_data: {
        action: "email_reassign_report_export",
        admin_id: this.admin_id,
        from_dt: from_date,
        to_dt: to_date,
        search_text: this.searchText || ''
      }
    };

    Swal.fire({
      html:
        '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      focusConfirm: false,
      background: 'transparent'
    });

    this.serverService.sendServer(api_req).subscribe(
      (response: any) => {

        Swal.close();

        if (response.status == true) {

          this.res = response;
          var arrStr = encodeURIComponent(JSON.stringify(this.res));
          var url = 'https://uatassaabloyccapi.mconnectapps.com/api/storage/email/email_reassign_report.php';
          var form = $('<form target="_blank" action="' + url + '" method="post">' + '<input type="text" name="res" value="' + arrStr + '" />' + '</form>');
          $('body').append(form);
          form.submit();

        } else {

          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: response.message || 'File not generated'
          });
        }

      },
      error => {

        Swal.close();

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong'
        });

        console.log(error);
      }
    );
  }


}